import { DetailHeader } from '../../../../commonComponents/DetailHeader';
import Styles from '../../../../../themes/style.module.scss';
import OfficeAvatarIcon from '../../../../../images/office-avatar.svg';
import StarIcon from '../../../../../images/star_Green.png';

/**
 * Banner across the top of the permanent-job detail page.
 *
 * Reuses the shared DetailHeader (the same banner the Profile / DSO / Staff
 * pages use) instead of the hand-rolled fixed-height copy this file used to
 * carry — that copy's `height: 125px` clipped the office name + rating + title
 * once they wrapped inside the sidebar-narrowed content column. DetailHeader
 * floors on `min-height` and lets the title ellipsize, so nothing clips.
 */
export const Header = ({ user, job }) => {
  const { profile_image: profileImage, average_rating: averageRating } = user || {};
  const officeName = job.officeName || user.office_name || '';
  const title = job.title ? `${officeName} | ${job.title}` : officeName;

  return (
    <DetailHeader
      tone="neutral"
      avatar={
        <img src={profileImage || OfficeAvatarIcon} className={Styles.profile_image} alt="office" />
      }
      title={title}
      meta={
        averageRating ? (
          <>
            <img src={StarIcon} width="20" height="20" alt="rating" />
            {averageRating.toFixed(1)}
          </>
        ) : null
      }
    />
  );
};
